<template>


    <div class="table-container">
        <div v-if="isLoading" class="js-loading-container">
            <div class="la-ball-clip-rotate js-loading la-2x">
                <div></div>
            </div>
        </div>

        <vdtnet-table
            :fields="fields"
            :opts="options"
            ref="table"
            className="table table-striped table-hover display"
            containerClassName=""
            :select-checkbox="0"
            :details="details"
        >
            <template
                slot="_details"
                slot-scope="ctx"
            >

                <div class="row reviewer-details">
                    <div class="col-4">
                        <div>
                            <strong>Gebruiker ingevoerd:</strong> {{ ctx.data.created_by }}
                        </div>
                        <div class="mt-2">
                            <strong>Datum/tijd ingevoerd:</strong> {{ ctx.data.created_at }}
                        </div>
                    </div>

                    <div class="col-4">
                        <div>
                            <strong>Gebruiker goedkeuring:</strong> {{ ctx.data.checked_by }}
                        </div>
                        <div class="mt-2">
                            <strong>Datum/tijd goedkeuring:</strong> {{ ctx.data.checked_at }}
                        </div>
                    </div>
                </div>

            </template>
        </vdtnet-table>
    </div>

</template>

<script>


export default {
    props: {
        isLoading: Boolean,
        isLoaded: Boolean,
        discountMutationsPerStation: Object,
        selectedProducts: Array,
        selectedStations: Array,
        startDate: String,
    },
    data() {
        return {
            details: {
                icons: ' '
            },

            options: {
                ajax: {
                    url: route('admin.api.discounts.index'),
                    "type": "GET",
                    "data": this.getDiscounts,
                    dataSrc: (json) => {
                        this.$emit('updateLoaded', false);

                        return json.data
                    }
                },
                columns: [
                    {title: 'Brandstof', data: 'product_name', className: "p-3 details-control font-weight-light no-sort"},
                    {title: 'Artikelnummer', data: 'article_code', className: "p-3 details-control font-weight-light no-sort"},
                    {
                        title: 'Voorgaande <br>pompkorting',
                        data: 'previous_discount',
                        className: "p-3 details-control font-weight-light no-sort"
                    },
                    {
                        title: 'Voorgaande <br>pompprijs',
                        data: 'previous_price',
                        className: "p-3 details-control font-weight-light no-sort"
                    },
                    {
                        title: 'Voorgaande pompkorting<br>(begindatum)',
                        data: 'previous_discount_datetime',
                        className: "p-3 details-control font-weight-light"
                    },
                    {title: 'Nieuwe <br>pompkorting', data: 'final_discount', className:
                            "p-3 details-control font-weight-light no-sort"},
                    {title: 'Nieuwe <br>pompprijs', data: 'final_price', className: "p-3 details-control font-weight-light no-sort"},
                    {
                        title: 'Nieuwe pompkorting<br>(begindatum)',
                        data: 'final_discount_datetime',
                        className: "p-3 details-control font-weight-light"
                    },
                    {
                        title: 'Gecorrigeerd <br>Pompkorting',
                        data: 'corrected_discount',
                        className: "p-3 details-control font-weight-light no-sort"
                    },
                    {
                        title: 'Status',
                        "render": function ( data, type, row, meta ) {
                            var status = JSON.parse(row.status || null);

                            if (status === 3) {
                                return '<img class="w-px-20" src="/assets/images/close.svg">';
                            }

                            if (status === 1) {
                                return '<img class="w-px-25" src="/assets/images/check-green.svg">';
                            }
                            if (status === 2) {
                                return '<img class="w-px-20" src="/assets/images/refresh.svg">';
                            }

                            return '';
                        },
                        className: "p-3 details-control font-weight-light no-sort"
                    },
                ],
                "columnDefs": [{
                    "targets": 0,
                    "createdCell": function (td, cellData, rowData, row, col) {

                        var correctedDiscount = JSON.parse(rowData.discount_corrected);

                        if (correctedDiscount) {
                            $(td).css('background-color', 'red')
                        } else {
                            $(td).css('background-color', 'green')
                        }
                    }
                }],
                serverSide: true,
                searching: false,
                lengthChange: false,
                pageLength: 10,
                order: [],
                processing: true,
                bFilter: false,
                rowGroup: {
                    dataSrc: 'station_batch_number',
                    startClassName: 'dtrg-group start-group',
                    startRender: function (rows, station_batch_number) {
                        return rows.data()[0]['station_name'];
                    }
                },
                "oLanguage": {
                    sProcessing: '<div class="la-ball-clip-rotate js-loading la-2x"><div></div></div>',
                    "sLengthMenu": "_MENU_ resultaten weergeven",
                    "sZeroRecords": "Geen resultaten gevonden",
                    "sInfo": "_START_ - _END_ van _TOTAL_ items",
                    "sInfoEmpty": 'Geen resultaten om weer te geven',
                    "sInfoFiltered": "(gefilterd uit _MAX_ resultaten)",
                    "sSearch": "Zoeken:",
                    "sEmptyTable": "Geen resultaten aanwezig in de tabel",
                    "sInfoThousands": ".",
                    "sLoadingRecords": "Een moment geduld aub - bezig met laden...",
                    "oPaginate": {
                        "sFirst": "Eerste",
                        "sLast": "Laatste",
                        "sNext": "",
                        "sPrevious": "",
                    },
                    "oAria": {
                        "sSortAscending": ": activeer om kolom oplopend te sorteren",
                        "sSortDescending": ": activeer om kolom aflopend te sorteren"
                    }
                }
            },

            fields: {}
        }
    },


    computed: {
        allRowsDiscounted() {
            if (!this.isLoaded) {
                return
            }
            return true;
        },


    },

    watch: {},

    methods: {
        onLoaded() {
            $('[data-toggle="tooltip"]').tooltip()
        },
        reloadTable() {
            this.$refs.table.reload();
        },
        getDiscounts(data) {
            return {
                ...data,
                filter_stations: Object.values(this.selectedStations),
                filter_products: this.selectedProducts,
                filter_starting_date: this.startDate
            }


        }
    },
    mounted() {
        this.reloadTable()
    }
}
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/functions';
    @import '~bootstrap/scss/variables';

    .datepicker-container {
        position: relative;
    }

    td {
        white-space: nowrap;
    }

    tr {
        height: 135px;
    }

    button[type=submit]:disabled {
        pointer-events: none;
    }

    .js-loading-container {
        background: rgba(255, 255, 255, .73);
        display: block;
        height: 100%;
        padding: 50px 0;
        position: absolute;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 10;
    }

    .table-container {
        position: relative;
    }

    th {
        white-space: nowrap;
    }
</style>
